export default function chooseDeliveryTime() {
  return {
    event: 'basket_click_delivery_time',
  }
}
